__turbopack_context__.v({
  "brand_name_text": "styles-module-scss-module__ZLgOYq__brand_name_text",
  "classNameRoot": "styles-module-scss-module__ZLgOYq__classNameRoot",
  "content": "styles-module-scss-module__ZLgOYq__content",
  "locationImage": "styles-module-scss-module__ZLgOYq__locationImage",
  "root": "styles-module-scss-module__ZLgOYq__root",
});
